import { Box, FormGroup, Modal, Typography, IconButton, Paper } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import NoteIcon from "@mui/icons-material/Note";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { fontSize } from "../theme/fontSize";
import { fontWeight } from "../theme/fontWeight";
import { FontFamily } from "../theme/fontFamily";
import { ThemeColor } from "../theme/color";
import moment from "moment";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { showSnackbar } from "../../Redux/action/SnackbarAction";
import { GetStudentNotesByIdAction } from "../../Redux/action/ApplicationAction";
import { AddStudentNotesService, DeleteStudentNotesService } from "../../Redux/service/Application";
import ConfirmationModal from "../Modal/ConfirmationModal/ConfirmationModal";
import OutlinedInputField from "../inputfiled/OutlinedInput";
import CustomButton from "../button/button";
import { Form, Formik } from "formik";
import SOCKET_EVENTS from "../../socket/events";
import { connectSocket } from "../../socket/socketClient";


const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "95%", sm: "85%", md: "650px" },
  height: "75vh",
  maxHeight: "650px",
  bgcolor: "#FFFFFF",
  borderRadius: "16px",
  boxShadow: "0 20px 50px rgba(0, 0, 0, 0.15)",
  border: "none",
  outline: "none",
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
};

export const StudentNotesModal = ({ NoteModal, handleClose, stdId, Studentlist }) => {
  const dispatch = useDispatch();
  const [confirmationopen, setConfirmationOpen] = useState(false);
  const [NotesByIdlist, setNotesByIdlist] = useState([]);
  const [noteId, setNoteId] = useState();

  const NotesByIdlistState = useSelector(
    (state) => state.application?.studentnotes?.data?.data
  );

  useEffect(() => {
    setNotesByIdlist(NotesByIdlistState);
  }, [NotesByIdlistState]);

  useEffect(() => {
    if (!NoteModal || !stdId) return;

    const socket = connectSocket();
    if (!socket) return;

    socket.emit(SOCKET_EVENTS.STUDENT_NOTES_JOIN, { studentId: stdId });

    const handleNewNote = (payload) => {
      if (String(payload?.studentId) === String(stdId) && payload?.note) {
        setNotesByIdlist((prev) => {
          if (!prev) return prev;
          const messages = prev.messages || [];
          const exists = messages.some(
            (m) => String(m._id) === String(payload.note._id)
          );
          if (exists) return prev;
          return {
            ...prev,
            messages: [...messages, payload.note],
          };
        });
      }
    };

    const handleDeletedNote = (payload) => {
      if (String(payload?.studentId) === String(stdId)) {
        setNotesByIdlist((prev) => {
          if (!prev) return prev;
          if (payload?.messageId === "all") {
            return { ...prev, messages: [] };
          }
          return {
            ...prev,
            messages: (prev.messages || []).filter(
              (m) => String(m._id) !== String(payload.messageId)
            ),
          };
        });
      }
    };

    socket.on(SOCKET_EVENTS.STUDENT_NOTES_NEW, handleNewNote);
    socket.on(SOCKET_EVENTS.STUDENT_NOTES_DELETED, handleDeletedNote);

    return () => {
      socket.emit(SOCKET_EVENTS.STUDENT_NOTES_LEAVE, { studentId: stdId });
      socket.off(SOCKET_EVENTS.STUDENT_NOTES_NEW, handleNewNote);
      socket.off(SOCKET_EVENTS.STUDENT_NOTES_DELETED, handleDeletedNote);
    };
  }, [NoteModal, stdId]);


  const currentStudent = Studentlist?.find(
    (data) => data.id === stdId || data._id === stdId
  );
  const studentName =
    currentStudent?.studentFirstName ||
    currentStudent?.firstName ||
    "";

  return (
    <>
      <Modal
        open={NoteModal}
        onClose={() => handleClose()}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={modalStyle}>
          {/* Header */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              px: 3,
              py: 2,
              bgcolor: ThemeColor.PURPLE,
              color: "#FFFFFF",
            }}
          >
            <Box display="flex" alignItems="center" gap={1.5}>
              <NoteIcon sx={{ color: "#FFF", fontSize: 22 }} />
              <Typography
                fontFamily={FontFamily.Poppins}
                fontWeight={fontWeight.W600}
                fontSize={fontSize.h3.medium}
                color="#FFFFFF"
              >
                {studentName ? `Notes for "${studentName}"` : "Notes"}
              </Typography>
            </Box>
            <IconButton
              onClick={() => handleClose()}
              size="small"
              sx={{
                color: "#FFFFFF",
                bgcolor: "rgba(255, 255, 255, 0.15)",
                "&:hover": { bgcolor: "rgba(255, 255, 255, 0.3)" },
              }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>

          {/* Notes List */}
          <Box
            sx={{
              flex: 1,
              overflowY: "auto",
              px: 3,
              py: 2.5,
              backgroundColor: "#F8FAFC",
              display: "flex",
              flexDirection: "column",
              gap: 2,
              '&::-webkit-scrollbar': { width: '6px' },
              '&::-webkit-scrollbar-track': { background: '#F1F5F9' },
              '&::-webkit-scrollbar-thumb': { background: '#CBD5E1', borderRadius: '10px' },
              '&::-webkit-scrollbar-thumb:hover': { background: '#94A3B8' },
            }}
          >
            {NotesByIdlist?.messages?.map((data, index) => (
              <Paper
                key={index}
                elevation={0}
                sx={{
                  p: 2,
                  borderRadius: "12px",
                  bgcolor: "#FFFFFF",
                  border: "1px solid #E2E8F0",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.03)",
                }}
              >
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                  <Typography
                    fontFamily={FontFamily.Poppins}
                    fontWeight={fontWeight.W600}
                    fontSize="0.8rem"
                    color={ThemeColor.PURPLE}
                  >
                    {data.sender?.firstName} {data.sender?.lastName}
                  </Typography>
                  <Typography
                    fontFamily={FontFamily.Poppins}
                    fontSize="0.75rem"
                    color="#94A3B8"
                  >
                    {moment.unix(data.dateTime).format("MMM D, YYYY h:mm A")}
                  </Typography>
                </Box>
                <Typography
                  fontFamily={FontFamily.Poppins}
                  fontWeight={fontWeight.W400}
                  fontSize="0.9rem"
                  color="#334155"
                  lineHeight={1.5}
                  mb={1}
                >
                  {data.text}
                </Typography>
                <Box display="flex" justifyContent="flex-end">
                  <IconButton
                    size="small"
                    onClick={() => {
                      setNoteId(data._id);
                      setConfirmationOpen(true);
                    }}
                    sx={{ color: ThemeColor.RED, "&:hover": { bgcolor: "#FEE2E2" } }}
                  >
                    <DeleteOutlineIcon fontSize="small" />
                  </IconButton>
                </Box>
              </Paper>
            ))}
          </Box>

          {/* Form Footer */}
          <Formik
            initialValues={{ text: "" }}
            onSubmit={async (values, { resetForm }) => {
              values["student"] = stdId;
              await AddStudentNotesService(values)
                .then((res) => {
                  if (res.status === 200) {
                    dispatch(GetStudentNotesByIdAction(stdId));
                    resetForm();
                  }
                })
                .catch((e) => {
                  console.error("Error adding note:", e);
                });
            }}
          >
            {({ values, errors, handleChange, handleSubmit }) => (
              <Box
                component="form"
                onSubmit={handleSubmit}
                sx={{
                  p: 2,
                  bgcolor: "#FFFFFF",
                  borderTop: "1px solid #E2E8F0",
                }}
              >
                <Box display="flex" alignItems="center" gap={1.5}>
                  <Box flex={1}>
                    <OutlinedInputField
                      value={values.text}
                      name={"text"}
                      onChange={handleChange}
                      placeholder="Add note text..."
                      fullWidth={true}
                      helperText={errors.text}
                    />
                  </Box>
                  <CustomButton
                    variant="contained"
                    type="submit"
                    backgroundColor={ThemeColor.PURPLE}
                    color={ThemeColor.WHITE}
                  >
                    Add
                  </CustomButton>
                </Box>
              </Box>
            )}
          </Formik>
        </Box>
      </Modal>

      <ConfirmationModal
        handleConfirmationClose={() => {
          setConfirmationOpen(false);
        }}
        deletefunction={async () => {
          try {
            const res = await DeleteStudentNotesService({ stdId, noteId });
            if (res.status === 200) {
              dispatch(GetStudentNotesByIdAction(stdId));
              return res;
            } else {
              return Promise.reject("Unexpected response status");
            }
          } catch (e) {
            dispatch(
              showSnackbar(
                e.response?.data?.message || "Error occurred",
                "error"
              )
            );
            return e;
          }
        }}
        confirmationopen={confirmationopen}
        message={"All deleted notes will not be retrievable"}
      />
    </>
  );
};
